/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	/**
	 * SDXTabs Image Skin.
	 * Not based on sdx-tabs Web Component because it doesn't support Images.
	 *
	 * @author Ces, Nikola Bajkic
	 * @namespace Tc.Module
	 * @class Image
	 * @extends Tc.Module
	 */
	Module.SDXTabs.Image = function(parent) {

		this.on = function (callback) {
			var mod = this;
			mod.log('on-Image', mod.tabId, mod.$tabs.length);

			mod.$tabContainer = mod.$ctx.find('.tabitems');
			mod.$tabContainer.on('scroll', function () {
				var offset = mod.getScrolledOffset();
				mod.setOverflowShadows(offset);
			});
			mod.setOverflowShadows();

			parent.on.call(this, callback);
		};

		/**
		 * Preselect a tab based on hash parameters.
		 */
		this.deepLinking = function () {
			var mod = this;

			var selectedTabIndex = parent.deepLinking.call(this);
			mod.setActiveState(selectedTabIndex);
			mod.switchToPanel(selectedTabIndex);
			mod.log('deepLinking-Image', mod.tabId, selectedTabIndex);
		};

		/**
		 * Attach click event on tabs, and handle hashchange event.
		 */
		this.addEvents = function () {
			var mod = this;

			mod.$tabs.on('click', mod.handleTabClicked.bind(mod));
			mod.$tabs.on('click', mod.handleTracking.bind(mod));
			window.addEventListener('hashchange', mod.deepLinking.bind(mod));
		};

		/**
		 * Scroll tab to position.
		 *
		 * @param {number} index - index of current tab
		 */
		this.scrollTab = function (index) {
			var mod = this,
				targetPosition;

			var $tab = mod.$tabs.eq(index).closest('div'),
				tabWidth = $tab.outerWidth(true);
			var leftPosition = $tab[0].offsetLeft,
				leftDistance = leftPosition - mod.getScrolledOffset();
			var rightPosition = leftDistance + tabWidth,
				rightDistance = mod.$tabContainer.width() - rightPosition;

			if (leftDistance < tabWidth || rightDistance < tabWidth) {
				targetPosition = leftPosition - (mod.$tabContainer.width() - tabWidth)/2;
				mod.$tabContainer.animate({ scrollLeft: targetPosition }, 400, 'linear');
			}
			mod.log('scrollTab', leftDistance, rightDistance, targetPosition);
		};

		this.getScrolledOffset = function () {
			var mod = this;

			return mod.$ctx[0].getBoundingClientRect().left - mod.$tabs[0].getBoundingClientRect().left;
		};

		this.setOverflowShadows = function (offset) {
			var mod = this,
				hasOverflow = mod.$tabContainer[0].scrollWidth > mod.$ctx.width();

			if (hasOverflow) {
				if (!offset || offset === 0) {
					mod.$ctx.removeClass('overflowLeft');
					mod.$ctx.addClass('overflowRight');
				} else if (offset > 0 && offset < mod.$tabContainer[0].scrollWidth - mod.$tabContainer.width()) {
					mod.$ctx.addClass('overflowLeft');
					mod.$ctx.addClass('overflowRight');
				} else {
					mod.$ctx.addClass('overflowLeft');
					mod.$ctx.removeClass('overflowRight');
				}
			}
		};

		/**
		 * Update hash parameters and active state.
		 *
		 * @param {Object} event - the click event
		 */
		this.handleTabClicked = function (event) {
			var mod = this,
				$tab = $(event.currentTarget),
				selectedTabIndex = mod.$tabs.index($tab),
				hash = $tab.data('hash');

			if ($tab.is('.disabled')) {
				return;
			}
			if (hash) {
				location.hash = hash;
			} else {
				SCS.HashDeepLink.set(mod.tabId, ($tab.data('panel') || selectedTabIndex), '&');
			}
			mod.setActiveState(selectedTabIndex);
			mod.switchToPanel(selectedTabIndex);
			mod.log('handleTabClicked', mod.tabId, selectedTabIndex, hash);
		};

		/**
		 * Activate a tab.
		 *
		 * @param {number} selectedTabIndex - the tab to select
		 */
		this.setActiveState = function (selectedTabIndex) {
			var mod = this,
				i = selectedTabIndex < mod.$tabs.length ? selectedTabIndex : 0;

			mod.$tabs.removeClass('active').blur().eq(i).addClass('active');
		};

		/**
		 * Show the panel of the selected tab, and hide the others.
		 * Scroll the selected image tab into view.
		 *
		 * @param {number} selectedTabIndex - the tab of which the panel should be shown
		 */
		this.switchToPanel = function (selectedTabIndex) {
			var mod = this;
			parent.switchToPanel.call(mod, selectedTabIndex);

			if (!isNaN(selectedTabIndex) && (selectedTabIndex < 10) && !SCS.utils.isMobilePage()) {
				mod.scrollTab(selectedTabIndex);
			}
		};

		this.handleTracking = function (event) {
			var $target = $(event.currentTarget);
			var trackLabel = $target.data('track-label'),
				trackCategory = $target.data('track-category');

			SCS.portal.datalayer.trackEvent('view', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
		};
	};
}(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXTabs.Image.js
// module id = 371
// module chunks = 0